import { useState, useMemo } from 'react';

/** Hook for managing loading/error states in fetching/requesting something.
 */
function useLoader(initialState){
  const [loading, setLoading] = useState(initialState);
  const [error, setError] = useState();

  const loadFn = useMemo(() => async (asyncAction, loadText) => {
    setLoading(loadText || true);
    setError();

    try {
      const result = await asyncAction();
      setLoading(false);
      return {result, error: null};
  } catch(e){
      setError(e.message);
      setLoading(false);
      return {result: null, error: e};
    }
  }, []);
    
  return [loading, error, loadFn];
}

export default useLoader;
